import React from "react";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";
import CryptoJS from "crypto-js";

const secretKey = "clave-super-secreta";

export const SidebarDataGestor = () => {
  const cookies = new Cookies();

  const correo = cookies.get("correo") || "";
  const nombre = cookies.get("Nombre") || "Usuario";

  const correoCifrado = CryptoJS.AES.encrypt(correo, secretKey).toString();
  const correoCodificado = encodeURIComponent(correoCifrado);

  return [
    {
      title: <span style={{ fontSize: "18px" }}>{nombre}</span>,
      path: "/Home/" + correoCodificado,
      icon: <IoIcons.IoIosPerson />,
    },
    {
      title: "Gestión de Usuarios",
      path: "/InfoUsuarios",
      icon: <IoIcons.IoMdPeople />,
    },
    {
      title: "",
      path: "/",
      icon: <CerrarSesion />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
  ];
};
